// Settings (first version): push on this device, add a passkey for another device, log out.
import { useState } from 'react';
import { startRegistration } from '@simplewebauthn/browser';
import { api } from '../api';
import { Label, Panel, ThemeSwitch } from '../ui';
import { Connections } from './Connections';
import { Guidance } from './Brain';
import { Prefs } from './Prefs';

const b64 = (s: string) => { const p = '='.repeat((4 - (s.length % 4)) % 4); const r = atob((s + p).replace(/-/g, '+').replace(/_/g, '/')); return Uint8Array.from(r, (c) => c.charCodeAt(0)); };

export function Settings({ onLogout }: { onLogout: () => void }) {
  const [msg, setMsg] = useState('');
  const say = (p: Promise<string>) => p.then(setMsg).catch((e) => setMsg(e?.message || 'Hiba.'));

  const enablePush = () => say((async () => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return 'Ezen az eszközön nincs push. iPhone-on előbb tedd a kezdőképernyőre.';
    if ((await Notification.requestPermission()) !== 'granted') return 'Az értesítés nincs engedélyezve.';
    const reg = await navigator.serviceWorker.ready;
    const { key } = await api<{ key: string }>('/api/push/key');
    const sub = (await reg.pushManager.getSubscription()) ?? (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64(key) }));
    await api('/api/push/subscribe', sub.toJSON());
    const r = await api<{ reached: number }>('/api/push/test', {});
    return `Push bekapcsolva (${r.reached} eszköz kapta meg a próbát).`;
  })());

  const addPasskey = () => say((async () => {
    const { options, ticket } = await api('/api/auth/register/options', {});
    const response = await startRegistration({ optionsJSON: options });
    await api('/api/auth/register/verify', { ticket, response, label: /Windows/.test(navigator.userAgent) ? 'Windows' : /iPhone/.test(navigator.userAgent) ? 'iPhone' : 'eszköz' });
    return 'Az új passkey elmentve.';
  })());

  const logout = async () => { await api('/api/auth/logout', {}); onLogout(); };

  return (
    <div className="j-stack">
      <Guidance />
      <Connections />
      <Prefs />
      <Panel c="violet"><Label c="violet">Téma</Label><div style={{ marginTop: 10 }}><ThemeSwitch /></div></Panel>
      <Panel c="mint"><Label c="mint">Értesítések</Label><p className="muted">Push ezen az eszközön (iPhone-on csak a kezdőképernyőről indított appban).</p>
        <button className="j-btn j-btn--primary" onClick={enablePush}>Push bekapcsolása</button></Panel>
      <Panel c="cyan"><Label c="cyan">Passkeyk</Label><p className="muted">Egy másik eszköz vagy jelszókezelő felvétele (pl. a laptop).</p>
        <button className="j-btn" onClick={addPasskey}>Passkey hozzáadása</button></Panel>
      <Panel c="coral"><Label c="coral">Kilépés</Label><button className="j-btn" onClick={logout} style={{ marginTop: 10 }}>Kilépés ezen az eszközön</button></Panel>
      {msg && <p className="muted">{msg}</p>}
    </div>
  );
}
